import axios from "axios"
import { v4 as uuidv4 } from "uuid"

const sessionId = uuidv4()
let interval: any

export default function startSessionTracking() {
    sessionHeartbeat()
    if (interval) {
        clearInterval(interval)
    }
    interval = setInterval(() => sessionHeartbeat(), 300000)
}

function sessionHeartbeat() {
    if (sessionId) {
        axios
            .put(`${window.encoway.baseUrl}/api/showroom/sessiontracking/id/${sessionId}`, {withCredentials: true})
            .then((res) => {
                if (res.status !== 200) {
                    console.error(`Error: Received status code ${res.status}`)
                }
            })
            .catch((error) => {
                console.error(`Request failed: ${error}`)
            })
    }
}
